// Signup forms. Two stages, one look (see template-parts/signup-form.php):
//
//  1. Demo form (.js-signup-demo) — rendered while a placement's Customizer
//     shortcode is empty. Validates client-side, sends NOTHING, then walks
//     to the "check your email" page like a real send would.
//  2. Real Contact Form 7 form — CF7 does the validation and the sending;
//     this file only listens to its DOM events to focus the first error
//     and to go to the thanks page once the mail went out.
import gsap from "gsap";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const reduceMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function remember(email) {
  try {
    sessionStorage.setItem("wps_email", email);
  } catch (error) {
    /* storage can be blocked — nothing depends on it */
  }
}

function shake(el) {
  if (!el || reduceMotion()) return;
  gsap.fromTo(el, { x: -9 }, { x: 0, duration: 0.6, ease: "elastic.out(1, 0.25)", clearProps: "transform" });
}

function initDemoForms() {
  document.querySelectorAll(".js-signup-demo").forEach((form) => {
    const wrap = form.closest(".js-signup");
    const email = form.querySelector('input[name="email"]');
    const error = form.querySelector("[data-error]");
    const button = form.querySelector('button[type="submit"]');
    const label = button ? button.textContent : "";

    const showError = (on) => {
      email.setAttribute("aria-invalid", on ? "true" : "false");
      if (error) error.hidden = !on;
    };

    email.addEventListener("input", () => showError(false));

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const value = email.value.trim();

      if (!EMAIL_RE.test(value)) {
        showError(true);
        shake(email);
        email.focus();
        return;
      }

      remember(value);
      button.disabled = true;
      button.textContent = "Sending…";

      // Demo only: no request is made.
      window.setTimeout(() => {
        window.location.href = wrap.dataset.thanksUrl || "/check-email/";
      }, 700);

      // If the user comes back via the browser's back button.
      window.addEventListener("pageshow", () => {
        button.disabled = false;
        button.textContent = label;
      }, { once: true });
    });
  });
}

function initContactForm7() {
  // CF7 dispatches these on the .wpcf7 wrapper and they bubble.
  document.addEventListener("wpcf7mailsent", (event) => {
    const wrap = event.target.closest(".js-signup");
    if (!wrap) return;

    const inputs = (event.detail && event.detail.inputs) || [];
    const email = inputs.find((input) => input.name === "your-email");
    if (email) remember(email.value);

    window.location.href = wrap.dataset.thanksUrl || "/check-email/";
  });

  document.addEventListener("wpcf7invalid", (event) => {
    const first = event.target.querySelector(".wpcf7-not-valid");
    if (first) {
      shake(first);
      // CF7 moves focus to its own response region right after this event.
      window.setTimeout(() => first.focus(), 60);
    }
  });
}

export function initSignup() {
  initDemoForms();
  initContactForm7();
}
